import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/report'
  }
}

export default {
  /**
   * Area Analysis 조회
   */
  getFaultChartAreas: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/fault-chart/areas')
    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * EQP Model Analysis 조회
   */
  getFaultChartEqpModels: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/fault-chart/eqp-models')
    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * EQP Analysis 조회
   */
  getFaultChartEqps: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/fault-chart/eqps')
    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * FD Model Analysis 조회
   */
  getFaultChartModels: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/fault-chart/models')
    await axios
      .get(url, { params: payload })
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * SPC Model Status List 조회
   * @param {Object} payload 조회 조건(fab, area, eqpModel, startDt, endDt)
   * @returns
   */
  getSpcModelStatus: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/model-status', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
